import styled from 'styled-components';
import {
  Modal as SemanticModal,
} from 'semantic-ui-react';

import { Button as ButtonLayoutComponent } from '@playbookux/playbook-web-core';

export const Modal = styled(SemanticModal)``;

export const Button = styled(ButtonLayoutComponent)`
    &.ui.button {
      width: 70px;
  }
`;

export const ContainerTitle = styled(SemanticModal.Content)`
  & {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-weight: 500;
  }
`;

export const ContainerDescription = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;

`;

export const ContainerButton = styled(SemanticModal.Content)`
  &&& {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
